import Vue from 'vue';
import './icons';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
//import '../static/css/theme-green/index.scss';       // 浅绿色主题
// 导入下拉树样式
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// table样式
import 'vxe-table/lib/index.css';
import App from './App';
import store from './store';
import router from './router';
import permission from './directive/permission';
import * as filters from './filters'; // 过滤器
import loading from './common/js/load.js'; //loading
import { Base64 } from 'js-base64';
import baseRequest from './common/js/baseRequest';
import globalVar from './common/js/global';
import globalMixins from './common/mixins/globalMixins';

import {
  getButtons,
  getRouteMenuCode,
  alert,
  confirm,
  getColumnList,
  filterEmpty,
  toFixedNumber,
  toFixedNumberAmount,
  toFixedPrice,
  toFixedAmout,
  toFixedQuantity,
  reportErrors,
} from './common/js/util';
import formatter from './common/js/formatter';
import Status from './common/js/status'; // 字典表申请单状态
import httpService from './service/http-service';
//国际化
import i18n from './common/lang'; // Internationalization
//vxe-table
import 'xe-utils';
import VXETable from 'vxe-table';
import XEUtils from 'xe-utils/methods/xe-utils';
import VXETablePluginElement from 'vxe-table-plugin-element';

import '../node_modules/bpmn-js/dist/assets/diagram-js.css';
import '../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import '../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css';
import '../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';

// 下拉树
import Treeselect from '@riophae/vue-treeselect';
//计算方法
import cal from './common/js/calculation';
// import * as echarts from 'echarts';
import CustomComponent from './components';

Vue.component('treeselect', Treeselect);

Vue.use(permission);
Vue.mixin(globalMixins);
//基础UI组件-elementUi
Vue.use(ElementUI, {
  size: 'small',
});
//可编辑的表格组件
Vue.use(VXETable);
//将可编辑的表格表头图标去掉
VXETable.setup({
  icon: {
    TABLE_EDIT: '',
  },
  size: 'small', // 全局尺寸
  table: {
    border: true,
    stripe: true, // 条纹
    resizable: true, // 列是否允许拖动列宽调整大小
    showOverflow: true, // 当内容过长时显示为省略号
    highlightHoverRow: true, // 鼠标移到行是否要高亮显示
    highlightCurrentRow: true, // 是否要高亮当前行
    scrollY: {
      // 纵向虚拟滚动配置（不支持深层结构和展开行）
      rHeight: 36, // 当启用虚拟滚动后，该参数用于设置每一行的固定高度
    },
  },
});
//默认阻止默认事件
VXETable.interceptor.add('event.clearActived', (params, event) => {
  let stopClass = [
    'el-popover',
    'sirui-modal-search',
    'el-form',
    'el-row',
    'el-col',
    'el-form-item',
    'el-form-item__label',
    'el-form-item__content',
    'el-input',
    'el-input__inner',
    'el-button',
    'sirui-table',
    'vxe-table--loading',
    'vxe-toolbar',
    'vxe-table--main-wrapper',
    'vxe-table--header-wrapper',
    'vxe-table--header',
    'vxe-header--column',
    'vxe-cell',
    'vxe-resizable',
    'col--gutter',
    'vxe-table--body',
    'vxe-body--column',
    'vxe-radio--icon',
    'el-pagination',
    'el-pagination__total',
    'el-pagination__sizes',
    'el-input__suffix',
    'el-select__caret',
    'btn-prev',
    'el-icon',
    'el-pager',
    'number',
    'btn-next',
    'el-pagination__jump',
    'search-modal-footer',
    'footer-button',
    'search-expand',
  ];
  let status = true;
  for (let i = 0; i < stopClass.length; i++) {
    // 比如点击了某个组件的弹出层面板之后，此时被激活单元格不应该被自动关闭，通过返回 false 可以阻止默认的行为。
    if (event.target.className.indexOf(stopClass[i]) > -1) {
      status = false;
      break;
    }
  }
  return status;
});
Vue.use(VXETable);
VXETable.use(VXETablePluginElement);
Vue.use(CustomComponent);

// 创建一个简单的超链接渲染
VXETable.renderer.add('getDetailNo', {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    console.log(h, renderOpts);
    let { column } = params;
    // let { events } = renderOpts;
    console.log(column);
    return [12];
  },
});

// Vue.prototype.$echarts = echarts; //全局引入echarts图标内容

Vue.prototype.loading = loading;

Vue.prototype.status = Status;

Vue.prototype.getButtons = getButtons;

Vue.prototype.Base64 = Base64;

Vue.prototype.getRouteMenuCode = getRouteMenuCode;

Vue.prototype.getColumnList = getColumnList;

Vue.prototype.$alert = alert;

Vue.prototype.filterEmpty = filterEmpty;

Vue.prototype.$confirmAction = confirm;

Vue.prototype.$utils = XEUtils;

Vue.prototype.$axios = httpService;

Vue.prototype.$repeatAlert = ElementUI.MessageBox.alert;

Vue.prototype.$repeatConfirm = ElementUI.MessageBox.confirm;

Vue.prototype.$cal = cal;

Vue.prototype.$baseRequest = baseRequest;

Vue.prototype.$globalVar = globalVar;

Vue.prototype.$formatter = formatter;

Vue.prototype.$toFixedNumber = toFixedNumber;

Vue.prototype.$toFixedNumberAmount = toFixedNumberAmount;

Vue.prototype.$toFixedPrice = toFixedPrice;

Vue.prototype.$toFixedAmout = toFixedAmout;

Vue.prototype.$toFixedQuantity = toFixedQuantity;

Vue.prototype.$reportErrors = reportErrors;

const on = Vue.prototype.$on;

// 节流
Vue.prototype.$on = function (event, func) {
  let previous = 0;
  let newFunc = func;
  if (event === 'click') {
    newFunc = function () {
      const now = new Date().getTime();
      if (previous + 1000 <= now) {
        func.apply(this, arguments);
        previous = now;
      }
    };
  }
  on.call(this, event, newFunc);
};

//过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

window.vm = new Vue({
  i18n,
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
